import { FC } from 'react';

import chillDudeImg from 'assets/brand/chill.png';
import magnifyingGlass from 'assets/brand/mag-glass.png';
import useDebounce from 'common/hooks/useDebounce';
import Button from 'components/_core/Button';
import { useModal } from 'components/ModalProvider/hooks';
import { useFilters } from 'features/Work/pages/hooks/useFilters';

import { ClientModalType } from '../../../../../../pages/Clients/components/Modals/types';
import WorkListEmptyView from '../../../../../WorkListEmptyView';
import locales from './locales';

const EmptyView: FC = () => {
  const { showModal } = useModal();
  const { filters, updateFilters } = useFilters();

  // Here we compare with the debounced value because when cleaning the input,
  // the hasFilters change while the list has not been refetched yet
  const debouncedSearch = useDebounce(filters.q);
  const debouncedStatusFilters = useDebounce(filters.statuses);
  const hasFilters =
    Boolean(debouncedSearch) || Boolean(debouncedStatusFilters?.length);

  return (
    <WorkListEmptyView
      imageSrc={hasFilters ? magnifyingGlass : chillDudeImg}
      title={hasFilters ? locales.noResult : locales.title}
    >
      <Button
        icon="arrow-right"
        marginTop="space-14"
        onClick={() =>
          hasFilters
            ? updateFilters({ q: '' })
            : showModal(ClientModalType.CreateEdit)
        }
        variant="inline-primary"
      >
        {hasFilters ? locales.reset : locales.create}
      </Button>
    </WorkListEmptyView>
  );
};

export default EmptyView;
